import React, {useContext} from "react";
import {ListBox, ListDivider, ListItem, ListItemLabel, ListTitle,} from "../../ui/ListStyles";
import {Link} from "react-router-dom";
import {COLORS} from "../../ui/Theme";
import {MainLayoutContext} from "../../context/MainLayoutContext";
import {logout} from "../../lib/dashboard/actions";
import {Box} from "@mui/system";
import {Typography} from "@mui/material";

const UserDropdown = ({setIsOpenDropdown}) => {
    const {
        setMode,
        fullname,
        subscriptionData,
    } = useContext(MainLayoutContext);

    return (
        <ListBox
            sx={{
                position: "absolute",
                top: "110%",
                right: "1%",
            }}
        >
            <Box sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexDirection: "column",
                gap: "10px",
            }}>
                <ListTitle>{fullname}</ListTitle>
                {
                    subscriptionData?.map((item) => (
                        <Box
                            key={item.id}
                            sx={{display: "flex", gap: "5px"}}>
                            {
                                item.remained_days ? (
                                    <Typography sx={{

                                        fontSize: "10px",
                                        fontWeight: 700,
                                        color: COLORS.GRAY,
                                    }}>
                                        <span>اشتراک {item.feature_name}: </span>
                                        <span style={{color: COLORS.BLUE}}>{item.remained_days} روز</span>
                                    </Typography>
                                ) : (
                                    <Typography sx={{fontSize: "10px", fontWeight: 700, color: COLORS.RED}}>
                                        اشتراک شما به پایان رسیده
                                    </Typography>
                                )
                            }
                        </Box>
                    ))
                }
            </Box>
            <ListDivider/>

            <Link to="profile">
                <ListItem onClick={() => setIsOpenDropdown(false)}>
                    <ListItemLabel>پروفایل</ListItemLabel>
                </ListItem>
            </Link>

            {/*<ListItem*/}
            {/*    */}
            {/*  onClick={() => setMode((prev) => (prev === "light" ? "dark" : "light"))}*/}
            {/*>*/}
            {/*  <ListItemLabel*/}
            {/*    sx={{*/}
            {/*      display: "flex",*/}
            {/*      alignItems: "center",*/}
            {/*      justifyContent: "space-between",*/}
            {/*      width: "100%",*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    پوسته*/}
            {/*    <DarkmodeToggle />*/}
            {/*  </ListItemLabel>*/}
            {/*</ListItem>*/}

            <ListItem
                onClick={logout}
                sx={{
                    ":hover": {
                        background: COLORS.SOFTRED,
                    },
                }}
            >
                <ListItemLabel sx={{color: COLORS.RED, fontWeight: 600}}>
                    خروج
                </ListItemLabel>
            </ListItem>
        </ListBox>
    );
};

export default UserDropdown;
